export var UpdateNoteTabResultStatus;
(function (UpdateNoteTabResultStatus) {
    UpdateNoteTabResultStatus["SUCCESS"] = "SUCCESS";
    UpdateNoteTabResultStatus["CONFLICT"] = "CONFLICT";
    UpdateNoteTabResultStatus["ERROR"] = "ERROR";
})(UpdateNoteTabResultStatus || (UpdateNoteTabResultStatus = {}));
